import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './SyncIndicator.css';

/**
 * Affiche une icône animée pendant la synchronisation.
 * @param {object} props
 * @param {boolean} props.loading
 * @param {string} [props.className]
 */
export default function SyncIndicator(props) {
	if( props.loading ) {
		const className = ( props.className ) ? props.className : "display-5 spining" ;
		return (
			<React.Fragment>
				<FontAwesomeIcon icon={["fas" , "sync-alt"]} className={className}/>
			</React.Fragment>
		);
	}
	return null;
}
